export const brand = {
  teal: "#2A7D8C",
  tealDark: "#1F5E6B"
} as const

export const neutral = {
  ink: "#0F172A",
  muted: "#64748B",
  faint: "#94A3B8",
  border: "#E2E8F0",
  surface: "#F8FAFC",
  light: "#F1F5F9"
} as const

export const semantic = {
  success: "#22C55E",
  warning: "#F97316",
  error: "#EF4444",
  // Red that reads as text: #EF4444 is 3.8:1 on white, under the 4.5:1 a
  // figure or a warning label needs.
  errorText: "#B42318",
  star: "#F59E0B"
} as const

export const chipVariants = {
  ok: { bg: "rgba(34,197,94,.12)", fg: "#15803D" },
  warn: { bg: "rgba(249,115,22,.12)", fg: "#C2410C" },
  err: { bg: "rgba(239,68,68,.12)", fg: "#B91C1C" },
  muted: { bg: "#F1F5F9", fg: "#64748B" },
  // Same fill, darkened text: `muted` is 4.1:1 on its own tint, under the
  // 4.5:1 a small uppercase label needs. Same move as `semantic.errorText`.
  mutedStrong: { bg: "#F1F5F9", fg: "#475569" }
} as const

export type ChipVariant = keyof typeof chipVariants

export const iconTileTints = {
  teal: { bg: "rgba(42,125,140,.10)", fg: "#2A7D8C" },
  success: { bg: "rgba(34,197,94,.12)", fg: "#22C55E" },
  warning: { bg: "rgba(249,115,22,.12)", fg: "#F97316" },
  error: { bg: "rgba(239,68,68,.12)", fg: "#EF4444" }
} as const

export type IconTileVariant = keyof typeof iconTileTints

export const tealGhost = {
  bg: "rgba(42,125,140,.06)",
  border: "rgba(42,125,140,.3)",
  fg: "#2A7D8C"
} as const

export const chartSeries = {
  cashIn: "#69AEC0",
  cashOut: "#DCE4EC",
  net: "#287587"
} as const

export const shadows = {
  card: "0 1px 2px rgba(15,23,42,.05)"
} as const

export const widgetActionGap = 7
